import type {RailItem} from '@app/components/rail';
import {LandingRail} from '@app/components/rail';
import {LandingHeading, LandingParagraph, LandingSection} from '@tempo/landing';

type PlaylistSectionProps = {
	playlistItems: RailItem[];
	title?: React.ReactNode;
	description?: React.ReactNode;
	cta?: React.ReactElement;
};
export const PlaylistSection: React.FC<PlaylistSectionProps> = ({
	playlistItems,
	title,
	description,
	cta,
}) => {
	return (
		<LandingSection
			description={
				title && (
					<>
						<LandingHeading as="h2">{title}</LandingHeading>
						<LandingParagraph>{description}</LandingParagraph>
					</>
				)
			}
			cta={cta}
			overflow="hidden"
		>
			<LandingRail items={playlistItems} />
		</LandingSection>
	);
};
